import React, { useState } from 'react';
import * as Sentry from '@sentry/react';

import FormLocationField from 'retired/FormLocationField';
import addressToLocation from 'utils/addressToLocation';
import { renderAddress } from 'utils/renderAddress';

type FormLocationFieldProps = React.ComponentProps<typeof FormLocationField>;

/**
 * Take `FormLocationField` and make it work on `LocationObject` instead of strings
 */
export const FormLocationObjectField = (props: FormLocationFieldProps) => {
  const { value = '' } = props.input;

  const [location, setLocation] = useState(renderAddress(value.toJS ? value.toJS() : value));

  const onChange = async (selectedLocation: string) => {
    setLocation(selectedLocation);

    if (selectedLocation) {
      try {
        const { locationObject } = await addressToLocation(selectedLocation).toPromise();
        props.input.onChange(locationObject);
      } catch (errorMessage) {
        props.input.onChange(undefined);

        if (errorMessage !== 'ZERO_RESULTS') {
          Sentry.captureMessage(errorMessage as string, {
            level: 'info',
          });
        }
      }
    } else {
      props.input.onChange(undefined);
    }
  };

  return <FormLocationField {...props} input={{ ...props.input, value: location, onChange }} />;
};
